import { UserType } from '@shared/types/user-type';
import { UserLogin } from './user-login.model';

export class User extends UserLogin {
  email: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  birthday: Date | undefined;
  userType: UserType = UserType.CONSUMER;
  companyName: string | undefined;
  companyUuid?: string;
  currentLocation: string | undefined;
  profilePhoto: string | undefined;
  address: string | undefined;
  createdAt: Date | undefined;
  isVerified?: boolean;
  reviewCount?: number;
  eventCount?: number;
  notifyUpcomingRes?: boolean;
  notifyResDays?: number;
  notifyReviews?: boolean;
  lastSeenNotification?: string;

  get defaultRoute(): string | undefined {
    return this.userType === UserType.BUSINESS ? '/my-business' : '/business';
  }
}
